import { createIpaPlatform, createSandboxRosTemplate } from '@services/youtube-platform.service';
import { useTeamsData } from '@lib/hooks/useTeamsData';
import { useEffect, useState } from 'react';
import { getAuth } from '@services/identity.service';
import { getRosPreviewSession, setRosPreviewSession } from '@services/ros-preview.service';
import Sandbox from '@components/Sandbox';

export default function WebsiteSandboxPreviewPage({
  platform,
  oTemplateId
}: any) {
  const [platformId, setPlatformId] = useState(null);
  const [template, setTemplate] = useState(null);

  const teamContext = useTeamsData((s) => s.teamContext);

  const findOrCreateSandboxPlatform = async () => {
    const res = await createIpaPlatform({ userId: teamContext?.oid });
    setPlatformId(res.entity[0].platform_id);
  };

  const findOrFetchTemplate = async () => {
    const rosPreviewSession = getRosPreviewSession();

    if (!rosPreviewSession) return;

    const template = await createSandboxRosTemplate(rosPreviewSession);
    setTemplate(template.entity);
  };

  useEffect(() => {
    if (teamContext?.oid) {
      findOrCreateSandboxPlatform();
    }
  }, [teamContext]);

  useEffect(() => {
    if (oTemplateId) {
      const auth = getAuth();
      setRosPreviewSession(`${auth.id}:${oTemplateId}`);
    }
    findOrFetchTemplate();
  }, []);

  if (!platformId || !template) return null;

  return <Sandbox
    is_ros_preview={true}
    template={template}
    platform={platform}
    platformId={platformId}
  />;
}

export const getServerSideProps = async ({ query }: any) => {
  const {
    platform = 'zoom',
    oTemplateId = ''
  } = query;

  const props: any = { platform };
  if (oTemplateId) {
    props.oTemplateId = oTemplateId;
  }
  return { props };
};
